exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-inputs-wrapper {\n    display: flex;\n    justify-content: space-between;\n    width: 20%;\n    font-size: 15px;\n}\n\n.select-inputs-wrapper label {\n    margin-left: 3%;\n}\n\n.select-inputs-wrapper .account-type-select {\n    width: 65%;\n}", ""]);

// exports
